// import React, { useEffect, useState } from 'react';
// import FilesView from '../../../../Components/Utils/FilesView';

// function ViewEquipments({ item, data, open, onCancel }) {
//   const displayItem = data;
//   const [filePathList, setFilePathList] = useState([]);

//   useEffect(() => {
//     if (
//       data?.equipmentImage !== null &&
//       data?.equipmentImage !== "None" &&
//       data?.equipmentImage !== "[]"
//     ) {
//       setFilePathList(data?.equipmentImage?.length > 0 ? data?.equipmentImage : []);
//     }
//   }, [data]);

//   return (
//     <div className="w-full flex flex-col gap-6 p-6 bg-gradient-to-br from-gray-50 to-blue-50 rounded-xl shadow-lg max-w-2xl mx-auto">
//       {/* Header */}
//       <div className="border-b border-blue-200 pb-4">
//         <h2 className="text-2xl font-bold text-gray-800 flex items-center">
//           <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2z" />
//           </svg>
//           Equipment Details
//         </h2>
//       </div>

//       {/* Main Content */}
//       <div className="space-y-6">
//         {/* Equipment Name - Special treatment for long names */}
//         <div className="bg-white p-5 rounded-lg shadow-md border-l-4 border-blue-500">
//           <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1">Equipment Name</p>
//           <p className="text-lg font-medium text-gray-800 break-words min-h-[24px]">
//             {displayItem?.name || (
//               <span className="text-gray-400 italic">Not specified</span>
//             )}
//           </p>
//         </div>

//         {/* Details Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
//           <div className="bg-white p-4 rounded-lg shadow-sm">
//             <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Unit</p>
//             <p className="text-sm text-gray-700 mt-1">
//               {displayItem?.unit || (
//                 <span className="text-gray-400 italic">-</span>
//               )}
//             </p>
//           </div>
//           <div className="bg-white p-4 rounded-lg shadow-sm">
//             <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Brand</p>
//             <p className="text-sm text-gray-700 mt-1">
//               {displayItem?.brand || (
//                 <span className="text-gray-400 italic">-</span>
//               )}
//             </p>
//           </div>
//           <div className="bg-white p-4 rounded-lg shadow-sm">
//             <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Model No</p>
//             <p className="text-sm text-gray-700 mt-1">
//               {displayItem?.model || (
//                 <span className="text-gray-400 italic">-</span>
//               )}
//             </p>
//           </div>
//         </div>

//         {/* Attachments - Only shown if there are files */}
//         {filePathList.length > 0 && (
//           <div className="bg-white p-5 rounded-lg shadow-md border-l-4 border-blue-500">
//             <div className="flex items-center mb-3">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
//               </svg>
//               <p className="text-sm font-semibold text-gray-700">Attachments</p>
//             </div>
            
//             <div className="overflow-y-auto max-h-40 grid grid-cols-2 sm:grid-cols-3 gap-3 p-2 bg-gray-50 rounded-lg">
//               {filePathList.map((imgs, idx) => (
//                 <div key={idx} className="hover:scale-105 transition-transform duration-200">
//                   <FilesView fileView={imgs} />
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Footer */}
//       <div className="flex justify-end mt-4">
//         <button 
//           onClick={onCancel}
//           className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg transition-colors duration-200 flex items-center"
//         >
//           <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//           </svg>
//           Close
//         </button>
//       </div>
//     </div>
//   );
// }

// export default ViewEquipments;


import React, { useEffect, useState } from "react";
import FilesView from "../../../../Components/Utils/FilesView";

function ViewEquipments({ item, data, open, onCancel }) {
  const displayItem = data;

  const [filePathList, setFilePathList] = useState([]);

  useEffect(() => {
    if (
      data?.equipmentImage !== null &&
      data?.equipmentImage !== "None" &&
      data?.equipmentImage !== "[]"
    ) {
      setFilePathList(
        data?.equipmentImage?.length > 0 ? data?.equipmentImage : []
      );
    }
  }, [data]);

  return (
    <div className="w-full flex flex-col gap-5 p-3 rounded-xl bg-white shadow-sm">
      {/* Equipment Title */}
      <div>
        <p className="text-[14px] font-semibold text-mainColor-500 pb-1 border-b border-gray-200 mb-2">
          Equipment Details
        </p>
        <p className="text-sm text-gray-600">{displayItem?.name || "-"}</p>
      </div>

      {/* Equipment Info Grid */}
      <div className="grid grid-cols-3 gap-4">
        <div>
          <p className="text-[13px] font-medium text-mainColor-400 pb-1">
            Unit
          </p>
          <p className="text-sm text-gray-600">{displayItem?.unit || "-"}</p>
        </div>
        <div>
          <p className="text-[13px] font-medium text-mainColor-400 pb-1">
            Brand
          </p>
          <p className="text-sm text-gray-600">{displayItem?.brand || "-"}</p>
        </div>
        <div>
          <p className="text-[13px] font-medium text-mainColor-400 pb-1">
            Model No
          </p>
          <p className="text-sm text-gray-600">{displayItem?.model || "-"}</p>
        </div>
      </div>

      {/* Attachments */}
      {data?.equipmentImage?.length > 0 && (
        <>
          <div className="border-t pt-3">
            <p className="text-[13px] font-medium text-mainColor-400 mb-2">
              Attachments
            </p>
            <div className="overflow-y-auto max-h-32 p-2 border rounded-lg bg-gray-50">
              <div className="w-full flex gap-3 flex-wrap">
                {filePathList.map((imgs, idx) => (
                  <FilesView fileView={imgs} key={idx} />
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default ViewEquipments;
